/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'events',
        title: 'Events',
        type: 'basic',
        icon: 'mat_outline:event',
        link: '/events'
    },
    {
        id: 'exhibitors',
        title: 'Exhibitors',
        type: 'basic',
        icon: 'mat_outline:storefront',
        link: '/exhibitors'
    },
    {
        id: 'speakers',
        title: 'Speakers',
        type: 'basic',
        icon: 'mat_outline:record_voice_over',
        link: '/speakers'
    },
    {
        id: 'lead-questions',
        title: 'Lead Questions',
        type: 'basic',
        icon: 'mat_outline:quiz',
        link: '/lead-questions'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'mat_outline:people',
        link: '/users'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'mat_outline:assessment',
        link: '/reports'
    },
    {
        id: 'notifications',
        title: 'Notifications',
        type: 'basic',
        icon: 'mat_outline:notifications',
        link: '/notifications'
    },
    {
        id: 'app-config',
        title: 'App Config',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/app-config'
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'events',
        title: 'Events',
        type: 'basic',
        icon: 'mat_outline:event',
        link: '/events'
    },
    {
        id: 'exhibitors',
        title: 'Exhibitors',
        type: 'basic',
        icon: 'mat_outline:storefront',
        link: '/exhibitors'
    },
    {
        id: 'speakers',
        title: 'Speakers',
        type: 'basic',
        icon: 'mat_outline:record_voice_over',
        link: '/speakers'
    },
    {
        id: 'lead-questions',
        title: 'Lead Questions',
        type: 'basic',
        icon: 'mat_outline:quiz',
        link: '/lead-questions'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'mat_outline:people',
        link: '/users'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'mat_outline:assessment',
        link: '/reports'
    },
    {
        id: 'notifications',
        title: 'Notifications',
        type: 'basic',
        icon: 'mat_outline:notifications',
        link: '/notifications'
    },
    {
        id: 'app-config',
        title: 'App Config',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/app-config'
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'events',
        title: 'Events',
        type: 'basic',
        icon: 'mat_outline:event',
        link: '/events'
    },
    {
        id: 'exhibitors',
        title: 'Exhibitors',
        type: 'basic',
        icon: 'mat_outline:storefront',
        link: '/exhibitors'
    },
    {
        id: 'speakers',
        title: 'Speakers',
        type: 'basic',
        icon: 'mat_outline:record_voice_over',
        link: '/speakers'
    },
    {
        id: 'lead-questions',
        title: 'Lead Questions',
        type: 'basic',
        icon: 'mat_outline:quiz',
        link: '/lead-questions'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'mat_outline:people',
        link: '/users'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'mat_outline:assessment',
        link: '/reports'
    },
    {
        id: 'notifications',
        title: 'Notifications',
        type: 'basic',
        icon: 'mat_outline:notifications',
        link: '/notifications'
    },
    {
        id: 'app-config',
        title: 'App Config',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/app-config'
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'events',
        title: 'Events',
        type: 'basic',
        icon: 'mat_outline:event',
        link: '/events'
    },
    {
        id: 'exhibitors',
        title: 'Exhibitors',
        type: 'basic',
        icon: 'mat_outline:storefront',
        link: '/exhibitors'
    },
    {
        id: 'speakers',
        title: 'Speakers',
        type: 'basic',
        icon: 'mat_outline:record_voice_over',
        link: '/speakers'
    },
    {
        id: 'lead-questions',
        title: 'Lead Questions',
        type: 'basic',
        icon: 'mat_outline:quiz',
        link: '/lead-questions'
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'mat_outline:people',
        link: '/users'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'mat_outline:assessment',
        link: '/reports'
    },
    {
        id: 'notifications',
        title: 'Notifications',
        type: 'basic',
        icon: 'mat_outline:notifications',
        link: '/notifications'
    },
    {
        id: 'app-config',
        title: 'App Config',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/app-config'
    },
];
